// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e4cefd53","239":"bbc02b00","455":"44d65fd2"}[chunkId] + ".chunk.js";
};